import styled from "styled-components";
import { LITB_COLOR, LITB_NAV_COLOR } from "../../styles";
import { AssetImageUrl } from "../../../../assets/imgUrl";
export const NavArrow = styled.span `
	display: inline-block;
	width: 0;
	height: 0;
	border-right: 4px solid transparent;
	border-left: 4px solid transparent;
	content: "";
	border-top: 4px solid #999;
	vertical-align: 2px;
	margin-left: 3px;

	&.isShow {
		border-top: 4px solid ${LITB_COLOR};
		transform: rotate(180deg);
	}
`;
export const NavSplit = styled.span `
	position: relative;
	top: 1px;
	display: inline-block;
	width: 1px;
	height: 11px;
	background-color: #ccc;
	line-height: 11px;
	margin: 0 15px;
`;
export const NavSlash = styled(NavSplit) `
	margin-left: 0px;
	background: transparent;
	margin-right: 8px;
`;
export const NavModule = styled.div `
	text-align: left;
	position: relative;
	display: inline-block;
	font-size: 12px;
	font-weight: normal;
	color: #333333;
	line-height: 30px;

	&:hover ${NavArrow} {
		border-top: 4px solid ${LITB_COLOR};
		transform: rotate(180deg);
	}
`;
export const NavLink = styled.a `
	cursor: pointer;
	text-decoration: none;
	color: #333;

	&:hover {
		color: ${LITB_COLOR};
		text-decoration: none;
	}
`;
export const NavRegionFlag = styled.em `
	width: 16px;
	height: 13px;
	margin: 2px 3px 0px 5.5px;
	vertical-align: -2px;
	background: url(${AssetImageUrl["pc_flag"]}) no-repeat;
	display: inline-block;
	background-position-x: -999px;
	background-position-y: -999px;
`;
export const Nav = styled.div `
	position: relative;
	height: 30px;
	background-color: ${LITB_NAV_COLOR};
	text-align: right;
	z-index: 201;

	&::after,
	&::before {
		display: block;
		content: "";
		width: 100%;
		height: 30px;
		background-color: ${LITB_NAV_COLOR};
		position: absolute;
		top: 0;
	}

	&::before {
		left: -100%;
	}

	&::after {
		right: -100%;
	}
`;
export const NavAppModal = styled.div `
	display: none;
	/* left: -35.242px; */
	left: -64px;
	top: 30px;
	position: absolute;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
	border: 0;
	background: #fff;
	width: 210px;
	padding: 5px;
`;
export const NavApp = styled(NavModule) `
	margin-right: 4px;
	&:hover ${NavAppModal} {
		display: block;
	}
`;
export const NavAppModalIcons = styled.div `
	border-bottom: 0;
	overflow: hidden;
	margin-top: 10px;
	padding: 0 10px;
`;
export const NavQRCode = styled.em `
	z-index: 5;
	position: relative;
	float: left;
	margin: 0 8px 10px 0;
	width: 140px;
	height: 140px;
	background: url(${AssetImageUrl["pc_app"]}) -155px -5px no-repeat;
`;
export const NavIOS = styled.em `
	display: inline-block;
	vertical-align: top;
	margin-top: 1px;
	width: 30px;
	height: 30px;
	background: url(${AssetImageUrl["pc_app"]}) -361px -125px no-repeat;
	opacity: 1;
	padding-right: 0;
`;
export const NavAndroid = styled(NavIOS) `
	background: url(${AssetImageUrl["pc_app"]}) -361px -165px no-repeat;
`;
export const NavAppLink = styled(NavLink) `
	display: block;
	padding-top: 0;
	padding-bottom: 11px;

	&:hover ${NavIOS} {
		opacity: 0.8;
	}
`;
export const NavShipToModule = styled.div `
	text-align: left;
	position: relative;
	display: inline-block;
	font-size: 12px;
	font-weight: normal;
	color: #333333;
	line-height: 30px;
`;
export const NavShipTo = styled.strong `
	font-weight: normal;
`;
export const NavShipToModal = styled.div `
	width: 390px;
	box-sizing: border-box;
	background: #fff;
	border: 1px solid #dedede;
	padding: 15px;
	position: absolute;
	top: 30px;
	z-index: 10;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 4px;
	right: -75.375px;
`;
export const NavShipToModalTitle = styled.h4 `
	font-size: 14px;
	font-weight: normal;
	margin: 0 0 5px 0;
	padding: 0;
	text-align: left;
	line-height: 20px;
`;
export const NavShipToSelection = styled.div `
	margin-bottom: 15px;
	position: relative;
`;
export const NavShipToSelectionToggle = styled.a `
	display: inline-block;
	text-align: left;
	width: 336px;
	height: 38px;
	line-height: 38px;
	border: 1px solid #e6e6e6;
	padding: 0 10px;
	font-size: 14px;
	font-weight: normal;
	background: #fff;
	font: bold 16px/25px Helvetica;
	color: #333;
	text-decoration: none;
	vertical-align: middle;
	cursor: pointer;
`;
export const NavShipToSelectionToggleText = styled.span `
	font: bold 16px/25px Helvetica;
	color: #333;
	cursor: pointer;
	font-size: 14px;
	font-weight: normal;
	text-align: left;
	width: 336px;
	line-height: 38px;
`;
export const NavShipToArrow = styled(NavArrow) `
	float: right;
	margin: 15px 0 5px 5px;

	&.open {
		transform: rotate(180deg);
	}
`;
export const NavRegionModal = styled.div `
	border-width: 1px;
	border-style: solid;
	position: absolute;
	top: 100%;
	z-index: 1000;
	float: left;
	min-width: 160px;
	padding: 5px 0px;
	list-style: none;
	background-color: rgb(255, 255, 255);
	left: 0;
	border-color: rgb(230, 230, 230);
	right: 0px;
	border-top-width: 0px;
`;
export const NavRegionFilter = styled.div `
	position: relative;
`;
export const NavRegionSearchIcon = styled.img `
	position: absolute;
	left: 8px;
	top: 6px;
	width: 20px;
`;
export const NavRegionMenuInput = styled.input.attrs({
    placeholderTextColor: "#999999"
}) `
	border: 0;
	width: 286px;
	border-bottom: 1px solid #e6e6e6;
	line-height: 36px;
	height: 36px;
	padding: 0 35px;
	margin: 0;
	border-radius: 4px;
	vertical-align: middle;
	color: #555;
	font-size: 14px;
	display: inline-block;
	background-color: #fff;

	&:focus {
		outline: none;
	}
`;
export const NavRegionCountriesList = styled.ul `
	overflow-y: scroll;
	margin: 6px 0 0 0;
	position: relative;
	height: 320px !important;
`;
export const NavRegionCountryItem = styled.li `
	line-height: 32px !important;
	height: 32px !important;
	padding: 3px 37px !important;
	font-size: 14px;
	text-align: left;
	position: relative;
	white-space: normal;
	display: block;
	clear: both;
	font-weight: normal;
	color: #333;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		background: #f0f0f0;
	}
`;
export const NavRegionCountriesDivider = styled.li `
	height: 2px;
	margin: 9px 1px;
	overflow: hidden;
	background-color: #e5e5e5;
	border-bottom: 1px solid #fff;
`;
export const NavRegionSearchNoResult = styled.div `
	white-space: normal;
	padding: 6px 11px;
	position: absolute;
	overflow: hidden;
	word-break: break-word;
	text-align: left;
	line-height: 2em;
	width: auto;
`;
export const NavRegionInsideFlag = styled(NavRegionFlag) `
	position: absolute;
	left: 6px;
	top: 8px;
`;
export const NavCurrencySymbol = styled.span `
	display: inline-block;
	margin-right: 6px;
	font-size: 14px;
	text-align: left;
	font-weight: normal;
`;
export const NavCurrencyModal = styled.ul `
	margin-top: 0;
	background-color: #fff;
	overflow-y: scroll;
	max-height: 320px;
	display: block;
	text-align: left;
	font-size: 14px;
	border-right: 1px solid #e6e6e6;
	border-left: 1px solid #e6e6e6;
	border-bottom: 1px solid #e6e6e6;
	position: absolute;
	z-index: 1000;
`;
export const NavCurrencyItem = styled.li `
	float: left;
	width: 33%;
	border-right: 1px solid #e6e6e6;
	cursor: pointer;

	&:nth-child(3n + 3) {
		border-right: 0;
	}
`;
export const NavCurrency = styled.a `
	line-height: 38px !important;
	height: 38px !important;
	padding: 0 15px;
	display: block;

	&:hover {
		background: #f0f0f0;
	}
`;
export const NavCurrencyModalSymbol = styled.span `
	display: inline-block;
	margin-right: 20px;
`;
export const NavShipToSaveButton = styled.div `
	width: 360px;
	background: ${LITB_COLOR};
	line-height: 36px;
	height: 36px;
	text-align: center;
	font-size: 14px;
	color: #fff;
	cursor: pointer;
`;
export const NavLanguageModal = styled.div `
	display: none;
	border: 1px solid #dedede;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
	position: absolute;
	top: 30px !important;
	padding: 0 !important;
	right: 0;
`;
export const NavLanguage = styled(NavModule) `
	cursor: default;
	&:hover ${NavLanguageModal} {
		display: block;
	}
`;
export const NavLanguageList = styled.ul `
	background: #fff;
	color: #333;
	z-index: 10;
	text-align: left;
	border-radius: 4px;
	padding: 10px 0 10px 0;
	width: 100px;
	/* height: 250px;
	overflow: scroll; */
`;
export const NavLanguageItem = styled.li `
	margin: 0 !important;
	display: block !important;
`;
export const NavLanguageItemLink = styled.a `
	display: block !important;
	line-height: 24px;
	padding: 0 15px !important;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		background: #f0f0f0 !important;
		text-decoration: none;
		color: #333;
	}
`;
